<template>
    <div v-if="isMobile || windowWidth < 1200" class="page-header ion-padding-vertical">
        <ion-text color="secondary">
            <h1>{{ title }}</h1>
        </ion-text>
        <img src="@/assets/title-icon.png" />
    </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect'
export default {
    name: 'PageHeader',
    props: ['title'],
    data() {
        return {
            isMobile
        }
    }
}
</script>

<style lang="scss">
.page-header {
    text-align: center;

    ion-img {
        width: 10%;
        display: inline-block;
    }

    h1 {
        margin-top: 0;
        margin-bottom: 0;
        font-weight: 700;
    }
}

@media (min-width: 768px) {
    .page-header {
        h1 {
            font-size: 35px;
        }

        ion-img {
            margin-top: 10px;
        }
    }
}
</style>
